export class ErrorStatusMessageModel {
	title: string;
	body: string;
}

export enum TicketItemState {
	Unprocessed = 0,
	Done = 1
  }

  export enum DocumentTypeEnum {
	Normal = 1,
	VoidItem = 2,
	ChangeQuantity = 3
  }